import { SavedAttribute } from '../saved/saved-attribute.type';
import { ToCreateAttribute } from '../to-create/to-create-attribute.type';

export class Attribute {
  private _id?: number;
  private _name: string;
  private _tableId?: number;

  constructor(name: string) {
    this._name = name;
  }

  public static mapFromToCreateDto(dto: ToCreateAttribute): Attribute {
    return new Attribute(dto.name);
  }

  public static mapFromSaved(dto: SavedAttribute): Attribute {
    const attribute = new Attribute(dto.name);
    return attribute.setId(dto.id).setTableId(dto.tableId);
  }

  public static mapToSaved(attribute: Attribute): SavedAttribute {
    return {
      id: attribute._id as number,
      name: attribute._name,
      tableId: attribute._tableId as number,
    };
  }

  public static mapToToCreate(attribute: Attribute): ToCreateAttribute {
    return {
      name: attribute._name,
    };
  }

  public setId(id: number): Attribute {
    const attribute = new Attribute(this._name);
    attribute._tableId = this._tableId;
    attribute._id = id;
    return attribute;
  }

  public setTableId(tableId: number): Attribute {
    const attribute = new Attribute(this._name);
    attribute._tableId = tableId;
    attribute._id = this._id;
    return attribute;
  }

  get name(): string {
    return this._name;
  }
}
